import type { Property } from 'csstype';

import type { Color } from 'hb-react/types';

import type { ItemAttributes } from '.';

export enum BUTTON_MODE_OPTIONS {
  CUSTOM = 'custom',
  NETWORK = 'network',
}

export enum BUTTON_VARIANT_OPTIONS {
  DESTROY = 'destroy',
  DROPDOWN = 'dropdown',
  INVERSED = 'inversed',
  LINK = 'link',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export interface ButtonItemAttributes extends ItemAttributes {
  borderColor?: Color;
  borderWidth?: number;
  buttonBackgroundColor?: Color;
  buttonColor?: Color;
  buttonFontFamily?: string;
  buttonFontSize?: Property.FontSize | number;
  buttonFontWeight?: number;
  buttonLink?: string;
  buttonLinkNewPage?: boolean;
  buttonLineHeight?: number;
  buttonLetterSpacing?: Property.LetterSpacing;
  buttonPadding?: string;
  buttonRadius?: number;
  containerPadding: string | number;
  hasBorder?: boolean;
  horizontalAlign: 'left' | 'center' | 'right';
  hidden?: boolean;
  inversed?: boolean;
  mode?: BUTTON_MODE_OPTIONS;
  variant: BUTTON_VARIANT_OPTIONS;
  tied?: boolean;
}
